module.exports = __webpack_public_path__ + "static/media/man-die-palliatieve-zorg-krijgt-zit-thuis-achter-zijn-computer-large.1d67db85.jpg";